module.exports = __webpack_public_path__ + "static/MC_steps_reemplazo_FISICA_6_B-01c28dfd594414dbd4bc29abf0ba489b.gif";